<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right" ref="search">
      <el-form-item label="回收品类" prop="spidList">
        <el-select
          v-model="search.spidList"
          placeholder="请选择"
          clearable
          multiple
          style="width: 100%"
        >
          <el-option
            v-for="item in recycleCategoryList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="合作方名称" prop="partnerName">
        <el-input v-model="search.partnerName" placeholder="请输入" clearable />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="row-bg">
      <el-button type="primary" size="medium" @click="openCreateDialog"
        >创建</el-button
      >
      <el-button type="primary" size="medium" @click="batchDelete"
        >批量删除</el-button
      >
      <!-- <el-button type="primary" size="medium" @click="batchImport"
        >批量导入</el-button
      > -->
      <el-button type="primary" size="medium" @click="exportExcel"
        >导出</el-button
      >
    </div>
    <el-table
      ref="multipleTable"
      :data="tableData"
      v-loading="listLoading"
      @selection-change="handleSelectionChange"
      style="width: 100%"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column label="地区编号" prop="regionId" width="120" />
      <el-table-column label="回收品类" prop="spmc" width="150" />
      <el-table-column label="合作方名称" prop="partnerName" />
      <el-table-column label="区域范围" prop="regionName" width="200">
        <template slot-scope="scope">
          {{ formatRegion(scope.row.provinceName, scope.row.cityName) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="120" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="editItem(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="search.pageNum"
        :page-size="search.pageSize"
        :page-sizes="[10, 20]"
        :total="total"
      />
    </div>
    <create-order-area-dialog
      ref="createOrderAreaDialog"
      :visible.sync="createDialogVisible"
      :recycleCategoryList="recycleCategoryList"
      @onSuccess="handleSearch"
    />
    <commonBath
      ref="batchCommonRef"
      @opera-success="getList"
      :errUrl="'/autoapp-default-server-recovery/api/partnerManagementBond/downLoadFailInfo'"
      :downloadTemplateUrl="'/autoapp-default-server-recovery/api/partnerManagementBond/downLoadTemplate'"
      :importUrl="'/autoapp-default-server-recovery/api/partnerManagementBond/importPartnership'"
      :title="'批量导入'"
      :uploadTitle="'批量导入'"
    />
  </div>
</template>

<script>
import CreateOrderAreaDialog from "./component/createOrderAreaDialog.vue";
import commonBath from "@/components/commonBath.vue";
import {
  getOrderAreaList,
  getRecycleCategoryList,
  bathDel,
} from "@/api/recoveryManagement";

export default {
  name: "userOrderAreaManagement",
  components: {
    CreateOrderAreaDialog,
    commonBath,
  },
  data() {
    return {
      search: {
        spidList: [],
        partnerName: "",
        pageNum: 1,
        pageSize: 10,
      },
      recycleCategoryList: [],
      tableData: [],
      multipleSelection: [],
      listLoading: false,
      createDialogVisible: false,
      total: 0,
    };
  },
  created() {
    this.getList();
    this.getRecycleCategoryList();
  },
  methods: {
    // 格式化区域范围
    formatRegion(provinceName, cityName) {
      if (provinceName === cityName) {
        return provinceName;
      } else {
        return `${provinceName}-${cityName}`;
      }
    },
    async getList() {
      this.listLoading = true;
      try {
        const { statusCode, data, total } = await getOrderAreaList(this.search);

        if (statusCode === 200) {
          this.tableData = data.records || [];
          this.total = data.total;
        } else {
          this.$message.error("获取列表失败");
        }
      } catch (error) {
        this.$message.error("获取列表时发生错误");
        console.error(error);
      } finally {
        this.listLoading = false;
      }
    },
    async getRecycleCategoryList() {
      try {
        const { statusCode, data } = await getRecycleCategoryList();
        if (statusCode === 200) {
          this.recycleCategoryList = data.map((item) => ({
            value: item.spid,
            label: item.spmc,
          }));
        } else {
          this.$message.error("获取品类列表失败");
        }
      } catch (error) {
        this.$message.error("获取品类列表时发生错误");
        console.error(error);
      }
    },
    handleSearch() {
      this.search.pageNum = 1;
      this.getList();
    },
    resetForm() {
      this.$refs.search.resetFields();
      this.search.pageNum = 1;
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.search.pageSize = pageSize;
      this.search.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(pageNum) {
      this.search.pageNum = pageNum;
      this.getList();
    },
    openCreateDialog() {
      this.createDialogVisible = true;
      this.$refs.createOrderAreaDialog.editData = null;
    },
    async batchDelete() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请选择要删除的项");
        return;
      } else {
        const regionIds = this.multipleSelection
          .map((item) => item.regionId)
          .join(",");
        this.$dialog({
          title: "温馨提示",
          content: "是否批量删除",
          cancel_buttton: "否",
          ok_buttton: "是",
          width: "400px",
          footBtn: "card",
          dialogType: "delete",
          onOk: async () => {
            const { data, statusCode } = await bathDel(regionIds);
            if (statusCode == 200) {
              this.$message.success("批量删除成功");
              this.getList();
            }
          },
          onCancel: () => {
            console.log("cancel");
          },
        });
      }
    },
    exportExcel() {
      this.global
        .exportExcel(
          `/autoapp-default-server-recovery/api/area-management/user-order/export`,
          this.search,
          "用户订单区域管理",
          "post"
        )
        .catch((res) => {
          let blob = new Blob([res.response.data], {
            type: "application/json",
          });
          var blobReader = new Response(blob).json();
          blobReader.then((res) => {
            this.$message.error(res.message);
          });
        });
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    editItem(row) {
      this.createDialogVisible = true;
      const cityCode = row.cityCode.split(",");
      this.$refs.createOrderAreaDialog.editData = {
        provinceCode: row.provinceCode,
        provinceName: row.provinceName,
        cityCode: cityCode,
        cityName: row.cityName,
        spid: row.spid,
        partnerId: row.partnerId,
        partnerName: row.partnerName,
        regionId: row.regionId,
      };
    },
    batchImport() {
      this.$refs.batchCommonRef.openDialog();
    },
  },
};
</script>

<style scoped>
.row-bg {
  margin-bottom: 15px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/recoveryManagement/userOrderAreaManagement.vue